import defaultAvatar from '../assets/default_avatar.svg';

const PROFILE_AVATAR_CDN = 'https://dragondropvtt-avatars-public.s3.us-west-1.amazonaws.com/';

export const DEFAULT_PROFILE_AVATAR = defaultAvatar;

// URL for a profile avatar S3 key, or the bundled default when the user never uploaded one.
// Resolved at render time rather than written to the profile row, so every existing
// account without an upload gets it too, and an upload later simply replaces it.
// The key is encoded because it keeps the uploaded filename after its UUID prefix, so it
// can contain spaces — and callers put this into CSS url(), which drops the whole
// declaration on an unquoted space.
export function profileAvatarUrl(fileName) {
    if (!fileName) return DEFAULT_PROFILE_AVATAR;
    // A message sent from the tabletop as a character carries that character's portrait, which
    // lives in a different bucket (player-avatars) or on Dropbox, so it travels as a whole URL
    // rather than a key in this one. Anything already absolute is passed straight through.
    if (/^(https?:|data:|blob:|\/)/i.test(fileName)) return fileName;
    return PROFILE_AVATAR_CDN + encodeURIComponent(fileName);
}
